export const isOnScreen = (top, bottom) => {
  return top >= 0 || bottom >= 0;
};

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const monthShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getPostDate = (date) => {
  const d = new Date(date);
  return `${d.getDate()} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
};

export const getShortPostDate = (date) => {
  const d = new Date(date);
  return `${d.getDate()} ${monthShortNames[d.getMonth()]} ${d.getFullYear()}`;
};

export const getReadingTime = (wordsCount) => {
  const minutes = Math.floor(wordsCount / 120);
  return minutes >= 1 ? `${minutes} minute${minutes === 1 ? '' : 's'}` : '';
};
